import { FC } from "react";

import { App, Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";

import { IContract } from "../../../../types";
import { Content } from "../../../../components/Content";
import { PageHeader } from "../../../../components/PageHeader";
import { reports } from "../../../../services/reports";
import { getContracts } from "../../../../services/repositories";
import { ActionTable } from "../../../../components/ActionTable";
import { ActionFunction } from "../../../../components/ActionColumn";
import { usePagination } from "../../../../hooks";
import { Filter } from "./Filter";
import { NotFound } from "../../../../components/NotFound";

const ContractBilling: FC = () => {
  const { message } = App.useApp();
  const {
    data,
    isLoading,
    filter,
    setFilter,
    pagination,
  } = usePagination(getContracts);

  const columns: ColumnsType<IContract> = [
    {
      title: "ID",
      dataIndex: "sid",
      key: "sid",
      ellipsis: true,
      width: 70,
    },
    {
      title: "Contrato",
      dataIndex: "name",
      key: "name",
      ellipsis: true,
    },
    {
      title: "Serviços Realizados",
      dataIndex: "meta",
      key: "meta",
      ellipsis: true,
      render: (meta) => meta?.orders_count || "--",
    },
  ];

  const actions: ActionFunction<IContract> = (record) => {
    return [
      {
        key: "1",
        icon: <PrinterOutlined />,
        label: "Imprimir Registro",
        onClick: () => onPrint(record.id),
      },
    ];
  };

  const onPrint = (record?: string) => {
    if (record) {
      reports("contract-billing", { id: record });
      return;
    }
    if (filter && data.length > 0) {
      reports("contract-billing", filter);
      return;
    }
    if (filter && data.length === 0) {
      message.info("Não há registros para impressão.");
      return;
    }
    message.error("Você precisa filtar as informações!");
  };

  return (
    <>
      <PageHeader
        title="Relatório de Faturamento por contrato"
        backButton={false}
        actions={[
          <Button
            onClick={() => onPrint()}
            key={"print_table"}
            icon={<PrinterOutlined />}
            type="primary"
            disabled={data.length === 0}
          >
            Imprimir
          </Button>,
        ]}
        crumb
      />
      <Content margin>
        <Filter onSubmit={(values) => setFilter(values)} filter={filter} />
      </Content>
      <Content margin>
        <ActionTable
          actions={actions}
          pagination={pagination}
          size="small"
          loading={isLoading}
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={data}
          locale={{
            emptyText: <NotFound />,
          }}
        />
      </Content>
    </>
  );
};

export { ContractBilling };
